import store from '@/store'

export const RequireAutorization = async (to, from, next) => {
  const abilities = await store.dispatch('global/INIT')
  const isAuthenticated = store.getters['global/isAuthenticated']
  if (isAuthenticated) {
    if (abilities.includes(to.name)) {
      next()
    } else {
      next({ name: 'Dashboard' })
    }
  } else {
    next({ name: 'Login' })
  }
}
